import React from "react";
import { connect } from "dva";
import { Button, Tooltip } from "antd";
import { router } from "umi";
import OperateDropdown from "../../../../../../components/OperateDropdown";
import Container from "../../../../../../components/Container";
import ListPage from "../../../../../../components/ListPage";
import {
  getBureauNormSummaryDetail,
  getSchoolNormSummaryDetail
} from "../../../../../../services/activitySign/dataStatistic/normSummary";
import { GetQueryString } from "../../../../../../utils/utils";
import { url } from "../../../../../../services/service-utils";
import { getComposeUrl } from "../../../../../../utils/common";
import useRequest from "../../hooks/use-table-state";
import styles from "./index.less";

const { ListTable } = ListPage;

const NormSummaryDetail = props => {
  const appId = GetQueryString("appId") || 40;
  const activityBizId = GetQueryString("activityBizId");
  const indexName = GetQueryString("indexName");

  const { currentUser } = props;
  const { orgType } = currentUser || {};

  const { pageInfo, list, loading, handlePaginationChange } = useRequest(
    orgType === "school"
      ? getSchoolNormSummaryDetail
      : getBureauNormSummaryDetail,
    {
      initParams: {
        page: 1,
        pageSize: 10,
        activityBizId,
        indexName
      }
    }
  );

  const handleJump = record => {
    const { pathname } = window.location;
    const { nodeId, deptId } = record;
    if (orgType === "school") {
      router.push(
        getComposeUrl(
          `${pathname}/normDetail?activityBizId=${activityBizId}&indexName=${indexName}&deptId=${deptId}&appId=${appId}`
        )
      );
    } else {
      router.push(
        getComposeUrl(
          `${pathname}/normBureauDetail/${nodeId}?activityBizId=${activityBizId}&nodeId=${nodeId}&indexName=${indexName}&appId=${appId}`
        )
      );
    }
  };

  const isSchool = orgType === "school";

  const columns = [
    {
      title: isSchool ? "班级/部门名称" : "分组",
      dataIndex: isSchool ? "deptName" : "nodeName",
      key: isSchool ? "deptName" : "nodeName",
      width: 330,
      fixed: "left",
      render: deptName =>
        deptName ? (
          <Tooltip placement="top" title={deptName}>
            <span>
              {deptName && deptName.length <= 20
                ? deptName
                : `${deptName.substring(0, 20)}...`}
            </span>
          </Tooltip>
        ) : (
          "-"
        )
    },
    {
      title: "打卡总人数",
      dataIndex: isSchool ? "deptActionSum" : "joinSum",
      key: "deptActionSum",
      width: 120
    },
    {
      title: "打卡总次数",
      dataIndex: isSchool ? "deptJoinNum" : "joinNum",
      key: "deptJoinNum",
      width: 120
    },
    {
      title: "指标汇总",
      dataIndex: isSchool ? "deptItemSum" : "itemSum",
      key: "deptItemSum",
      width: 120
    },
    {
      title: "学生打卡人数",
      dataIndex: isSchool ? "stuActionSum" : "joinStuSum",
      key: "stuActionSum",
      width: 120
    },
    {
      title: "学生参与次数",
      dataIndex: isSchool ? "stuJoinNum" : "joinStuNum",
      key: "stuJoinNum",
      width: 120
    },
    {
      title: "学生指标汇总",
      dataIndex: isSchool ? "stuItemSum" : "itemStuSum",
      key: "stuItemSum",
      width: 120
    },
    {
      title: "教师打卡人数",
      dataIndex: isSchool ? "tecActionSum" : "joinTecSum",
      key: "tecActionSum",
      width: 120
    },
    {
      title: "教师参与次数",
      dataIndex: isSchool ? "tecJoinNum" : "joinTecNum",
      key: "tecJoinNum",
      width: 120
    },
    {
      title: "教师指标汇总",
      dataIndex: isSchool ? "tecItemSum" : "itemTecSum",
      key: "tecItemSum",
      width: 120
    },
    {
      title: "操作",
      key: "action",
      width: 120,
      fixed: "right",
      render: record => {
        const data = [
          {
            text: <a onClick={() => handleJump(record)}>详情</a>
          }
        ];
        return <OperateDropdown data={data} />;
      }
    }
  ];

  const containerProps = {
    breStates: 1,
    isPathParams: 1,
    defaultPadding: 1
  };

  const listPageProps = {
    spinProps: {
      spinning: loading
    }
  };

  const tableProps = {
    columns,
    list,
    pageInfo,
    onPageChange: handlePaginationChange
  };

  return (
    <Container {...containerProps}>
      <div className={styles.root}>
        <ListPage {...listPageProps}>
          <div className="buttonContainer">
            <Button
              type="primary"
              href={
                orgType === "school"
                  ? `${url.activitySign}/activity/item/download/exportSummarySchool/${activityBizId}/${indexName}?appId=${appId}`
                  : `${url.activitySign}/activity/item/download/exportSummaryEdu?appId=${appId}&activityBizId=${activityBizId}&indexName=${indexName}`
              }
            >
              导出
            </Button>
          </div>
          <ListTable {...tableProps} />
        </ListPage>
      </div>
    </Container>
  );
};

export default connect(({ user }) => ({
  ...user
}))(NormSummaryDetail);
